<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <div class="f-flex f-justify-between f-items-center f-mt-0.25 f-mb-1">
                <div class="f-w-5/10">
                    <calendar-facet-highlight-text-color
                        :value="highlight.highlightTextClass"
                        @input="onTextColorInput"
                    />
                </div>
                <div class="f-w-5/10">
                    <calendar-facet-highlight-bgcolor
                        :value="highlight.highlightBgClass"
                        @input="onBgColorInput"
                    />
                </div>
            </div>
        </template>
        <template slot="secondary">
            <div class="f-flex f-mt-0.25 f-ml-1">
                <toggle
                    :value="highlight.showHighlight"
                    :messages="messages"
                    @input="onInput"
                />
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-highlight';

export default {
    name: 'calendar-facet-highlight',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Show date Highlight',
            message: '',
            checked: false,
            messages: {
                checked: 'Yes',
                unchecked: 'No',
            },
            highlight: {
                showHighlight: false,
                highlightBgClass: '',
                highlightTextClass: '',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (isChecked) {
                this.highlight.showHighlight = true;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.highlight);
                this.selectedElements[0].showHighlight = true;
            } else {
                this.highlight.showHighlight = false;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.highlight);
                this.selectedElements[0].showHighlight = false;
            }

            this.checked = isChecked;
            this.onOptionChange(isChecked);
        },

        onBgColorInput(cssClass) {
            this.highlight.highlightBgClass = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.highlight);
            this.selectedElements[0].highlightBgClass = cssClass;
        },

        onTextColorInput(cssClass) {
            this.highlight.highlightTextClass = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.highlight);
            this.selectedElements[0].highlightTextClass = cssClass;
        },

        onSelectedElement() {
            this.highlight = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.highlight;
        },
    },
};
</script>
